module.exports = __webpack_public_path__ + "static/media/skewer.dbe5ec89.jpg";